import { useContext } from 'react'
import { CurrentUserContext } from '../components/User/UserProvider'

const useCurrentUser = () => {
    const currentUser = useContext(CurrentUserContext)

    if (currentUser === null) {
        throw new Error('[useCurrentUser] Current user is null!')
    }

    return currentUser
}
export default useCurrentUser
